export default __webpack_public_path__ + "static/media/empty-badge.36ac9ba3.png";